import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Row, Col } from 'antd';
import { requestAccountDeletion } from '../services/userService';
import logo from '../assets/logo.png';
import './AccountDeletionRequestPage.css';

const AccountDeletionRequestPage = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await requestAccountDeletion(values.mobileNumber, values.message);
      message.success('Your account deletion request has been submitted successfully.');
      form.resetFields();
    } catch (error) {
      message.error(error.response?.data?.message || 'Submission failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="deletion-request-container">
      <Card className="deletion-request-card">
        <div className="header-section">
            <img src={logo} alt="Krishna Interiors HRMS Logo" className="logo" />
            <h2>Krishna Interiors HRMS</h2>
            <p>Request Account Deletion</p>
        </div>
        <Form
          form={form}
          name="account_deletion_request"
          onFinish={onFinish}
          layout="vertical"
        >
          <Form.Item
            name="mobileNumber"
            label="Mobile Number"
            rules={[
              {
                required: true,
                message: 'Please input your mobile number!',
              },
              {
                pattern: /^[0-9]{10}$/,
                message: 'Please enter a valid 10-digit mobile number.',
              }
            ]}
          >
            <Input placeholder="Enter your 10-digit mobile number" />
          </Form.Item>

          <Form.Item
            name="message"
            label="Reason for Deletion"
            rules={[
              {
                required: true,
                message: 'Please provide a reason for your request!',
              },
            ]}
          >
            <Input.TextArea rows={4} placeholder="Please tell us why you want to delete your account..." />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Submit Request
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default AccountDeletionRequestPage; 